t<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <SelectInput
        :question="$t('home-type.question')"
        :selections="[
          {
            image: require('@/assets/house.svg'),
            name: $t('home-type.house'),
            value: 'house'
          },
          {
            image: require('@/assets/apartment.svg'),
            name: $t('home-type.apartment'),
            value: 'apartment'
          }
        ]"
        :selected-value="homeType"
        :clicked-callback="onSelect"
      ></SelectInput>
      <a @click="$router.push(getPrevStepUrl(step, $i18n.locale))" class="back-btn"
        >{{ $t('back') }}</a
      >
    </div>
  </div>
</template>

<script>
  import SelectInput from "../../components/SelectInput";
  import {mapMutations} from "vuex";
  import CalculatorHeading from "../../components/CalculatorHeading";
  import {getPrevStepUrl, getStepIndex, redirectToUnselectedStepIfAny} from "@/utils/steps.js";
  import {goToNextStep} from "../../utils/steps";

  export default {
  name: "HomeType",
  components: { CalculatorHeading, SelectInput },
  data() {
    return {
      step: getStepIndex("home-type"),
      getPrevStepUrl: getPrevStepUrl,
      homeType: this.$store.state.data.homeType
    };
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateHomeType"]),
    onSelect(value) {
      this.homeType = value;
      this.updateHomeType(value);
      goToNextStep(this.step, this.$i18n.locale, this.$router);
    }
  }
};
</script>
